import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { contactEmail } from '#app/utils/global.ts'

function SignupExistingAccount() {
  const { t } = useTranslation()

  return (
    <div className="border-mauve-6 border-t border-solid py-6 text-center">
      <p className="text-2">
        {t('signup.accessCode.existingAccount1')},{' '}
        <Link className="text-cyan-11" to="/sign-in">
          {t('signup.accessCode.existingAccount2')}
        </Link>
        .
      </p>
      <p className="text-2 mt-4">
        {t('signup.accessCode.needHelp')}{' '}
        <a className="text-cyan-11" href={`mailto:${contactEmail}`}>
          {t('signup.accessCode.contactUs')}
        </a>
        .
      </p>
    </div>
  )
}

export { SignupExistingAccount }
